import { render, staticRenderFns } from "./Scantron.vue?vue&type=template&id=019570bc&scoped=true"
import script from "./Scantron.vue?vue&type=script&lang=js"
export * from "./Scantron.vue?vue&type=script&lang=js"
import style0 from "./Scantron.vue?vue&type=style&index=0&id=019570bc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019570bc",
  null
  
)

export default component.exports